/**
 * 判斷當前環境是否為 App WebView
 * @param {string} [userAgent] - 可選的 User-Agent 字串，不提供時會使用 navigator.userAgent
 * @returns {boolean} 是否為 WebView 環境
 */
export const isWebview = (userAgent) => {
  const useragent = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '')
  if (!useragent) return false

  const rules = [
    'WebView',
    '(iPhone|iPod|iPad)(?!.*Safari/)', // iOS
    'Android.*(wv|Version/[0-9.]+.*Chrome)', // Chrome Android
    'Linux; U; Android' // 舊版 Chrome Android
  ]
  const regex = new RegExp(`(${rules.join('|')})`, 'ig')
  return Boolean(useragent.match(regex))
}

/**
 * 判斷是否為 Android 裝置
 * @param {string} [userAgent] - 可選的 User-Agent 字串，不提供時會使用 navigator.userAgent
 * @returns {boolean} 是否為 Android
 */
export const isAndroid = (userAgent) => {
  const ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '')
  if (!ua) return false
  // 排除 Windows Phone
  return /Android/i.test(ua) && !/Windows Phone/i.test(ua)
}

/**
 * 判斷是否為 iOS 裝置 (含 iPadOS 13+ 桌面偽裝)
 * @param {string} [userAgent] - 可選的 User-Agent 字串，不提供時會使用 navigator.userAgent
 * @returns {boolean} 是否為 iOS
 */
export const isIOS = (userAgent) => {
  const ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : '')
  if (!ua) return false
  // 傳統 iOS 裝置判斷
  const iOSClassic = /(iPhone|iPad|iPod)/i.test(ua)
  // iPadOS 13 之後 UA 可能類似 Mac，需加上觸控點判斷
  const iPadOS13Plus = !iOSClassic && typeof navigator !== 'undefined' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  return iOSClassic || iPadOS13Plus
}
